import { render, staticRenderFns } from "./RoomTablet.vue?vue&type=template&id=4c7cf80a&scoped=true"
import script from "./RoomTablet.vue?vue&type=script&lang=js"
export * from "./RoomTablet.vue?vue&type=script&lang=js"
import style0 from "./RoomTablet.vue?vue&type=style&index=0&id=4c7cf80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cf80a",
  null
  
)

export default component.exports